import { createFileRoute } from '@tanstack/react-router';

import type { NavigationSectionGroup } from '@/components/Navigation/NavigationCard';
import { CForm } from '@/features/c-form/CForm';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { AccountAccessActivitySection } from './-components/AccountAccessActivitySection';
import { AccountAccessAuditSection } from './-components/AccountAccessAuditSection';

export const Route = createFileRoute(
  '/_staff/software/$id/_$id/activity-monitoring/',
)({
  component: SoftwareActivityMonitoring,
});

function SoftwareActivityMonitoring() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.software.profile.activityMonitoring.navigation',
  });

  const navigationSectionGroups: NavigationSectionGroup[] = [
    {
      titleLabel: t('accountAccessActivity'),
      to: '',
      hash: 'account-access-activity',
    },
    {
      titleLabel: t('accountAccessAudit'),
      to: '',
      hash: 'account-access-audit',
    },
  ];

  return (
    <CForm
      editUnit="section"
      itemLayout="label"
      navigationSectionGroups={navigationSectionGroups}
      onReset={() => {}}
    >
      <AccountAccessActivitySection />
      <AccountAccessAuditSection />
    </CForm>
  );
}
